<template>
  <v-dialog v-model="showDialog" max-width="750px">
    <v-card>
      <v-card-title>
        <h3>{{ $vuetify.t('$vuetify.AdminUsers.bulkAddUserRole') }}</h3>
      </v-card-title>
      <v-card-text>
        <v-card class="mb-2">
          <v-card-title class="pb-0">
            <h4>{{ $vuetify.t('$vuetify.AdminUsers.selectedUsers') }}</h4>
          </v-card-title>
          <v-card-text>
            <span v-for="(user, index) in users">
              {{ user.first_name }} {{ user.last_name}} ({{ user.username }})
              <span v-if="(users.length - 1) !== index">, </span>
            </span>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title class="pb-0">
            <h4>{{ $vuetify.t('$vuetify.AdminUsers.selectUserRole') }}</h4>
          </v-card-title>
          <v-card-text>
            <v-layout row no-wrap>
              <v-flex xs12 sm6 class="mr-2">
                <v-select
                  v-model="selectedRole"
                  :items="roles"
                  :label="$vuetify.t('$vuetify.RoleEdit.userRole')"
                  item-text="name"
                  item-value="id"
                  hide-details />
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="selectedIdeaSpace"
                  :disabled="!hasRoleIdeaSpaceValidity"
                  :items="ideaSpaces"
                  :label="this.$vuetify.t('$vuetify.AdminUsers.formIdeaSpace')"/>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="this.selectedRole === null" color="primary" @click="bulkAddRole">
          {{ $vuetify.t('$vuetify.AdminUsers.formAddRole') }}
        </v-btn>
        <v-btn @click="closeDialog">
          {{ $vuetify.t('$vuetify.AdminUsers.formClose') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../api'
import {getIdeaSpaces} from '../../utils/ideaSpaces'
import {getUserRoles} from '../../utils/userRoles'

export default {
  name: 'UserRoleBulkAddDialog',
  props: {
    show: Boolean,
    users: Array
  },
  data () {
    return {
      roles: [],
      ideaSpaces: [],
      selectedRole: null,
      selectedIdeaSpace: null
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('handleClose', value)
      }
    },
    hasRoleIdeaSpaceValidity: function () {
      if (this.selectedRole) {
        let selectedRolePermissions = this.roles.find(role => role.id === this.selectedRole).permissions
        return this.$hasValidity(selectedRolePermissions, this.$validity.idea_space) ||
          this.$hasValidity(selectedRolePermissions, this.$validity.school_and_idea_space)
      }
      return false
    }
  },
  beforeMount: async function () {
    this.roles = await getUserRoles()
    this.ideaSpaces = await getIdeaSpaces(this.$store.getters.selected_school, this.$vuetify.t)
  },
  methods: {
    closeDialog: function () {
      this.$emit('reloadUsers')
      this.showDialog = false
    },
    bulkAddRole: function () {
      let userIds = this.users.map(usr => usr.id)
      api.user.addRoleBulk(this.$store.getters.selected_school, userIds, this.selectedRole, this.selectedIdeaSpace)
        .then(res => {
          if (res.status < 400) {
            // to-do: response error handling
            this.closeDialog()
          }
          this.closeDialog()
        })
    }
  }
}
</script>

<style scoped>

</style>
